import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { App } from "antd";
import { getPricingConfigs } from "../../store/slice/pricing";

export const usePricingManager = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { configs, isLoading, currentPricingModel, lastChanges } = useSelector(
    (state) => state.pricing
  );

  const handleRefreshConfigs = useCallback(() => {
    dispatch(getPricingConfigs());
  }, [dispatch]);

  const handleSave = useCallback((localityType) => {
    message.success(`Pricing for ${localityType} updated successfully!`);
    handleRefreshConfigs();
  }, [message, handleRefreshConfigs]);

  const handleExportConfig = useCallback(() => {
    try {
      const config = {
        model: currentPricingModel,
        timestamp: new Date().toISOString(),
        configs,
      };
      const dataStr = JSON.stringify(config, null, 2);
      const dataBlob = new Blob([dataStr], { type: "application/json" });
      const url = URL.createObjectURL(dataBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `pricing-config-${new Date().toISOString().split("T")[0]}.json`;
      link.click();
      URL.revokeObjectURL(url);
      message.success("Configuration exported successfully!");
    } catch (error) {
      message.error("Failed to export configuration");
    }
  }, [currentPricingModel, configs, message]);

  const getConfigByLocality = useCallback((localityKey) => {
    return configs.find((c) => c.localityType.toLowerCase() === localityKey.toLowerCase());
  }, [configs]);

  return {
    configs,
    isLoading,
    currentPricingModel,
    lastChanges,
    handleSave,
    handleExportConfig,
    handleRefreshConfigs,
    getConfigByLocality,
  };
};
